import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Title, Form } from 'components/layout'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { injectIntl, FormattedMessage } from 'react-intl'


@form({
  form: 'recover-participant-approval-modal',
  disableHook: true
})
@injectIntl
class RecoverDeletedParticipantApprovalModal extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    modalId: PropTypes.string,
    modal: PropTypes.func,
    isLoading: PropTypes.bool,
    deletedParticipantId: PropTypes.number,
    onApprove: PropTypes.func.isRequired
  }

  getModalDefaultMessage () {
    return 'Use Deleted Participant Report to find out deleted participant and then do not forget to unarchive him.'
  }

  render () {
    const {
      modalId,
      modal,
      handleSubmit,
      deletedParticipantId,
      isLoading,
      onApprove
    } = this.props

    return (
      <Modal id={modalId} modal={modal} customActions>
        <Title h2 intlKey="moduleTitle.recover_deleted_participant">
          Recover deleted participant
        </Title>
        <Form
          className="form"
          onSubmit={handleSubmit((onApprove))}
        >
          <div className="row">
            <div className="col-xs-12" style={{ marginBottom: '15px' }}>
              <FormattedMessage
                id="label.merge_account_modal_question"
                defaultMessage={this.getModalDefaultMessage()}
              />
              <br /><br />
              <p style={{ fontWeight: 'bold' }}>
                <FormattedMessage
                  id="label.merge_account_modal_question_detail"
                  defaultMessage='Are you sure to recover deleted participant {pid}?.'
                  values={{
                    pid: deletedParticipantId
                  }}
                />
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <Button
                intlKey="button.dismiss"
                onClick={() => this.props.modal(null)}
                secondary
                type="button"
                style={{ marginRight: 10 }}
              >
                Dismiss
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <Button
                isLoading={isLoading ? true : undefined}
                intlKey="button.approve"
                type="submit"
              >
                Approve
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    )
  }
}

export default RecoverDeletedParticipantApprovalModal
